import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.scss';
import { initializeAuthState } from './composables/useAuth';
import { setupChunkLoadErrorReload } from './utils/chunkReload';

initializeAuthState();
setupChunkLoadErrorReload();

const app = createApp(App);
app.use(router);

// Keep the server-rendered shell visible while Vue Router downloads and
// resolves the initial lazy-loaded page component. Once the route is ready,
// Vue can replace the shell with the interactive app without an empty gap.
router.isReady().then(() => {
  app.mount('#app');
});
